import site from '../content/site';
import ContactForm from './ContactForm';
import Reveal from './Reveal';

const Row = ({ label, children }) => (
  <div className="border-b-1 border-divider py-3.5">
    {label && <div className="text-label uppercase text-neutral-700">{label}</div>}
    {children}
  </div>
);

export default function ContactSection() {
  return (
    <section id="contact" aria-labelledby="contact-h" className="container-site py-sec-y">
      <div className="grid gap-x-10 gap-y-12 nav:grid-cols-[minmax(0,4fr)_minmax(0,8fr)]">
        <Reveal>
          <h2 id="contact-h" className="text-[clamp(36px,4.4vw,60px)] leading-[0.95] tracking-[-0.04em]">Tell us what you're building.</h2>
          <p className="mt-4 max-w-[380px] text-[16px]">We reply within one business day, usually with questions rather than a pitch.</p>
          <address className="mt-9 border-t-2 border-ink not-italic">
            <Row label="Email"><a href={`mailto:${site.email}`} className="font-semibold hover:text-accent">{site.email}</a></Row>
            <Row label="Phone"><a href={site.phoneHref} className="font-semibold hover:text-accent">{site.phone}</a></Row>
            <Row label="Office"><span className="font-semibold">{site.office}</span></Row>
            <Row><a href={site.linkedin} target="_blank" rel="noopener noreferrer" className="font-semibold text-accent-700">LinkedIn ↗</a></Row>
          </address>
        </Reveal>
        <Reveal className="border-2 border-ink bg-surface p-[clamp(20px,3vw,36px)]">
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
}
